(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/_request/bet.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/_request/bet.js');
'use strict';

class Bet {
  constructor(_ref) {
    let {
      productId,
      drawNum,
      numDraws,
      betProperties,
      betAmountSalesGroup1,
      betAmountSalesGroup2,
      rowPriceMulti,
      jokerBoards,
      lottoBoards,
      kenoBoards,
      numberboards,
      extNumberBoards,
      erNumberBoardData
    } = _ref;
    this.productId = productId;
    this.drawNum = drawNum;
    this.numDraws = numDraws;
    this.betProperties = betProperties;
    this.betAmountSalesGroup1 = betAmountSalesGroup1;
    if (betAmountSalesGroup2) {
      this.betAmountSalesGroup2 = betAmountSalesGroup2;
    }
    if (rowPriceMulti) {
      this.rowPriceMulti = rowPriceMulti;
    }
    if (jokerBoards) {
      this.jokerBoards = jokerBoards;
    }
    if (lottoBoards) {
      this.lottoBoards = lottoBoards;
    }
    if (kenoBoards) {
      this.kenoBoards = kenoBoards;
    }
    if (numberboards) {
      this.numberboards = numberboards;
    }
    if (extNumberBoards) {
      this.extNumberBoards = extNumberBoards;
    }
    if (erNumberBoardData) {
      this.erNumberBoardData = erNumberBoardData;
    }
  }
}
svs.tur.payment.api.jupiter.request.Bet = Bet;

 })(window);